import { ReactElement, useState } from 'react';
import { Diamond1Icon } from 'icons';
import { colors } from 'styles/colors';
import { UpgradeButton as StyledUpgradeButton, UpgradeModuleContainer } from './styles';
import { UpgradeModuleModal } from '../UpgradeModuleModal';
import { upgradeModuleDescriptions, UpgradeModules } from '../UpgradeModuleModal/constants';
import { useTranslation } from 'react-i18next';

interface UpgradeModuleContentProps {
  onClickUpgradeButton: () => void;
}

interface UpgradeButtonProps extends UpgradeModuleContentProps {
  onlyButton?: boolean;
}

interface UpgradeModuleProps {
  module: UpgradeModules;
  onlyButton?: boolean;
}

function UpgradeModuleContent({
  onClickUpgradeButton,
}: Readonly<UpgradeModuleContentProps>): ReactElement {
  const { t } = useTranslation();

  return (
    <>
      <div>
        <Diamond1Icon color={colors.icon['primary-base']} />
        <span>{t('adquiraMaisModulosDesbloquear')}</span>
      </div>
      <UpgradeButton onClickUpgradeButton={onClickUpgradeButton} />
    </>
  );
}

function UpgradeButton({
  onlyButton,
  onClickUpgradeButton,
}: Readonly<UpgradeButtonProps>): ReactElement {
  return (
    <StyledUpgradeButton
      type="button"
      variant="primary-stroke"
      onClick={onClickUpgradeButton}
      onlyButton={onlyButton}
    >
      <>
        <Diamond1Icon color={colors.icon['primary-base']} size="14" />
        <span>Upgrade</span>
      </>
    </StyledUpgradeButton>
  );
}

export function UpgradeModule({
  module,
  onlyButton,
}: Readonly<UpgradeModuleProps>): ReactElement {
  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);

  function onClickUpgradeButton(): void {
    setOpenUpgradeModal(true);
  }

  function onCloseModal(): void {
    setOpenUpgradeModal(false);
  }

  const upgradeModuleDescription = upgradeModuleDescriptions[module];

  return (
    <>
      <UpgradeModuleModal
        buttonLabel={upgradeModuleDescription.buttonLabel}
        description={upgradeModuleDescription.description}
        isOpen={openUpgradeModal}
        onClose={onCloseModal}
        subTitle={upgradeModuleDescription.subTitle}
        title={upgradeModuleDescription.title}
      />
      {onlyButton ? (
        <UpgradeButton onClickUpgradeButton={onClickUpgradeButton} onlyButton />
      ) : (
        <UpgradeModuleContainer id="upgrade-module-container">
          <UpgradeModuleContent onClickUpgradeButton={onClickUpgradeButton} />
        </UpgradeModuleContainer>
      )}
    </>
  );
}
